import { combineReducers } from 'redux';
import navigatorDataReducer from './navigatorDataReducer';
import navigatorUIReducer from './navigatorUIReducer';

export default combineReducers({
  data: navigatorDataReducer,
  ui: navigatorUIReducer,
});
